import dayjsTZ from "../../../../utils/dayjs";
import { getTranslation } from "../../generate/translations";
import { store } from "../../../../store";
import {
  getDayTypeTranslations,
  getShiftDuration,
} from "../approvals/approvals";
import { htmlParser } from "../../../../utils";

export const employeesLeave = (prevData, filter, columns, manualColumns) => {
  let toReturn = {
    columnsDef: [],
    allColumns: [],
    rowData: [],
    selectedColumns: [],
    allColumns: [],
  };

  const data = store?.getState().customReducer?.reportClockings;

  const holidayClockings = structuredClone(data || []).filter(
    (el) => el.dayType === "HolidayRequest"
  );

  if (!!data && !!filter) {
    toReturn.selectedColumns = manualColumns || columns.columnDefs;
    toReturn.allColumns = columns.allAppliedColumnDefs;

    const filteredData = holidayClockings
      .filter((el) => {
        let isWithinRange = false;
        const clockIn = el?.clockInDate;

        if (Array.isArray(filter.timeInterval) && !!clockIn) {
          const [start, end] = filter.timeInterval;
          isWithinRange = dayjsTZ(clockIn).isBetween(start, end, null, "[]");
        }
        const isSameEmployee = filter.employeeId
          ? el?.employeeDetails?.employeeId === filter.employeeId
          : true;

        return isWithinRange && isSameEmployee;
      })
      .map(({ employeeDetails = {}, ...rest }) => ({
        ...rest,
        ...employeeDetails,
        durationWithBreak: getShiftDuration(rest),
        clockInDate: getDate(rest.clockInDate, "HH:mm"),
        createdAt: getDate(rest.createdAt, "DD/MM/YYYY"),
        clockDate: getDate(rest.clockInDate, "DD/MM/YYYY"),
        dayType: getDayTypeTranslations(rest?.dayType || ""),
        approved: rest?.approved ? "Aprovuar" : "Pa Aprovuar",
        clockOutDate: getDate(rest.clockOutDate, "HH:mm", "Not Closed"),
        clockInNote: !!rest?.clockInNote ? htmlParser(rest?.clockInNote) : "",
        employeeFullName: `${employeeDetails.employeeFirstName} ${employeeDetails.employeeLastName}`,
        employeeDayOfBirth: getDate(
          employeeDetails?.employeeDayOfBirth,
          "DD/MM/YYYY"
        ),
        employeeHireDate: getDate(
          employeeDetails?.employeeHireDate,
          "DD/MM/YYYY"
        ),

      }));

    const array =
      !!manualColumns && Array.isArray(manualColumns)
        ? manualColumns
        : columns?.columnDefs || [];

    array.forEach((e) => {
      toReturn.columnsDef.push(getTranslation(e));
    });
    filteredData.forEach((cl) => {
      const toAdd = [];
      array.forEach((col) => toAdd.push(cl[col]));
      toReturn.rowData.push(toAdd);
    });
  }

  return toReturn;
};

const getDate = (date, format, fallback = "") =>
  !!date ? dayjsTZ(date).format(format) : fallback;
